import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  USER_GROUP_DELETE,
  USER_GROUP_GET,
  USER_GROUP_POST_UPDATE,
  USER_GROUP_PUT_CREATE,
} from '../endpoints/user-group.endpoints';

import { UserGroup } from 'src/app/core/models/core.models';
import { AppVersion } from 'src/app/core/constants';

import { Observable } from 'rxjs';

export interface UserGroupData {
  id?: string;
  title: string;
  description: string;
  companyId: string;
  company_id: string;
  member_ids: string[];
}

// TODO: We will pass typized objects to the services containing all inputs
@Injectable({ providedIn: 'root' })
export class UserGroupApiService {
  private readonly http = inject(HttpClient);

  getUserGroup(userGroupId: string): Observable<UserGroup> {
    return this.http.get<UserGroup>(USER_GROUP_GET(userGroupId));
  }

  /** Creates a user group (PUT /user_group/create). `version` pins the V3 user-group response shape. */
  createUserGroup(userGroupData: UserGroupData): Observable<UserGroup> {
    return this.http.put<UserGroup>(USER_GROUP_PUT_CREATE, {
      ...userGroupData,
      version: AppVersion.V3,
    });
  }

  /** Updates a user group (POST /user_group/update). `version` pins the V3 user-group response shape. */
  updateUserGroup(userGroupData: UserGroupData): Observable<UserGroup> {
    return this.http.post<UserGroup>(USER_GROUP_POST_UPDATE, {
      ...userGroupData,
      version: AppVersion.V3,
    });
  }

  deleteUserGroup(userGroupId: string): Observable<void> {
    return this.http.delete<void>(USER_GROUP_DELETE(userGroupId));
  }
}
